import { render } from "./roomview.vue?vue&type=template&id=61ea2144"
import script from "./roomview.vue?vue&type=script&lang=js"
export * from "./roomview.vue?vue&type=script&lang=js"

import "./roomview.vue?vue&type=style&index=0&id=61ea2144&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__